// extracted by mini-css-extract-plugin
export default {"picker_box":"DailyPowerCurve_picker_box__C2NzR","picker_pos":"DailyPowerCurve_picker_pos__Ck1RM"};